export default __webpack_public_path__ + "b9ba4bd843c827e7ed720f787d0ac608.png";